// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'https://provider.qalbs.com/',
  baseUrl: 'https://awmt.qalbs.com/',
  reportServerUrl:'https://awmt.qalbs.com/',
  CORPORATE_PANEL_URL: "https://conciergedev.transmedik.com/",
  TRACKING_URL: "https://membercaredev.nemtplatform.com/",
  PROVIDER_URL: 'https://awmtdev.transmedik.com/',
  OUTBOUND_CONVERSATION_BASE_URL: 'https://lawsuit.qalbs.com/',
  HMAC_CONVERSATION_SECRET: 'oP434TxeLaL5',
  OUT_BOUNDS_BASE_URL: 'https://moeezusaapi.nemtalk.com/outbound/', // in-house
  TRACKING_URL_CHG: "https://chg-memberdev.transmedik.com/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
